import { IDuration, TimePeriod } from '@alberta/konexi-shared';

export class DurationViewModel implements IDuration {
  amount: number;
  timePeriod: TimePeriod;
}
